@if (isReadOnly) {
  <mat-card class="p-4 w-7 mx-auto bg-grey-button form-lea-release">
    <dl class="lea-release-view">
      <div class="lea-release-view__row">
        <dt class="lea-release-view__label">Student Name</dt>
        <dd class="lea-release-view__value" data-pw="view_student_name" data-qa="view_student_name">
          {{ context.studentName || '—' }}
        </dd>
      </div>

      <div class="lea-release-view__row">
        <dt class="lea-release-view__label">Program</dt>
        <dd class="lea-release-view__value" data-pw="view_program" data-qa="view_program">
          {{ programLabel }}
        </dd>
      </div>

      <div class="lea-release-view__row">
        <dt class="lea-release-view__label">Description</dt>
        <dd class="lea-release-view__value" data-pw="view_description" data-qa="view_description">
          {{ context.description || '—' }}
        </dd>
      </div>

      <div class="lea-release-view__row">
        <dt class="lea-release-view__label">LEA Release</dt>
        <dd class="lea-release-view__value" data-pw="view_is_lea_release_approved" data-qa="view_is_lea_release_approved">
          {{ releaseDecisionLabel }}
        </dd>
      </div>
    </dl>
  </mat-card>
} @else {
<form [formGroup]="form" (submit)="submitForm()">
  <mat-card class="p-4 w-7 mx-auto bg-grey-button form-lea-release">
    <div class="edit-field my-1">
      <label for="studentName">Student Name</label>
      <input
        id="studentName"
        matInput
        formControlName="studentName"
        [readonly]="true"
        aria-readonly="true"
        data-pw="edit_student_name_input"
        data-qa="edit_student_name_input" />
    </div>

    <div class="edit-field my-1">
      <label for="programTypeCode">Program</label>
      <input
        id="programTypeCode"
        matInput
        formControlName="programTypeCode"
        [readonly]="true"
        aria-readonly="true"
        data-pw="edit_program_type_code_input"
        data-qa="edit_program_type_code_input" />
    </div>

    <div class="edit-field my-1">
      <label for="description">Description</label>
      <textarea
        id="description"
        matInput
        formControlName="description"
        rows="4"
        [readonly]="true"
        aria-readonly="true"
        data-pw="edit_description_input"
        data-qa="edit_description_input"></textarea>
    </div>

    <div class="form-lea-release__decision my-3">
      <mat-radio-group
        id="isLeaReleaseSignedRadioGroup"
        aria-label="Confirmation"
        aria-required="true"
        formControlName="isLeaReleaseSigned"
        class="form-lea-release__radio-group"
        data-pw="radio_is_lea_release_signed"
        data-qa="radio_is_lea_release_signed">
        <mat-radio-button
          [value]="true"
          data-pw="radio_is_lea_release_signed_yes"
          data-qa="radio_is_lea_release_signed_yes">
          I confirm and agree to the above statements
        </mat-radio-button>
      </mat-radio-group>
    </div>

    <div class="edit-field my-1">
      <label for="parentFirstName">
        Parent First Name
        <span class="form-lea-release__required" aria-hidden="true">*</span>
      </label>
      <input
        id="parentFirstName"
        matInput
        formControlName="parentFirstName"
        data-pw="edit_parent_first_name_input"
        data-qa="edit_parent_first_name_input" />
    </div>

    <div class="edit-field my-1">
      <label for="parentLastName">
        Parent Last Name
        <span class="form-lea-release__required" aria-hidden="true">*</span>
      </label>
      <input
        id="parentLastName"
        matInput
        formControlName="parentLastName"
        data-pw="edit_parent_last_name_input"
        data-qa="edit_parent_last_name_input" />
    </div>

    @if (!form.disabled) {
      <div class="button-row">
        <button
          aria-labelledby="Go Back Action"
          color="primary"
          data-qa="cancel_button"
          data-pw="cancel_button"
          mat-stroked-button
          tabindex="0"
          (click)="onBack()"
          (keyup)="($event.key === 'Enter' || $event.key === ' ') && onBack()">
          Cancel
        </button>
        <button
          mat-flat-button
          type="submit"
          [disabled]="!isFormReady()"
          color="primary"
          data-pw="submit_button"
          data-qa="submit_button">
          Submit
        </button>
      </div>
    }
  </mat-card>
</form>
}
